// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SlugRouteImport } from './routes/$slug'
import { Route as SplatRouteImport } from './routes/$'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SlugIndexRouteImport } from './routes/$slug/index'
import { Route as SlugScoreRouteImport } from './routes/$slug/score'
import { Route as SlugOfferRouteImport } from './routes/$slug/offer'
import { Route as SlugEpisodesRouteImport } from './routes/$slug/episodes'
import { Route as SlugGameEpisodeIdRouteImport } from './routes/$slug/game.$episodeId'
import { Route as SlugOfferEpisodeIdRouteImport } from './routes/$slug/offer.$episodeId'

const SlugRoute = SlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => rootRouteImport
          })
const SplatRoute = SplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const SlugIndexRoute = SlugIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => SlugRoute
          })
const SlugScoreRoute = SlugScoreRouteImport.update({
            id: '/score',path: '/score',getParentRoute: () => SlugRoute
          })
const SlugOfferRoute = SlugOfferRouteImport.update({
            id: '/offer',path: '/offer',getParentRoute: () => SlugRoute
          })
const SlugEpisodesRoute = SlugEpisodesRouteImport.update({
            id: '/episodes',path: '/episodes',getParentRoute: () => SlugRoute
          })
const SlugGameEpisodeIdRoute = SlugGameEpisodeIdRouteImport.update({
            id: '/game/$episodeId',path: '/game/$episodeId',getParentRoute: () => SlugRoute
          })
const SlugOfferEpisodeIdRoute = SlugOfferEpisodeIdRouteImport.update({
            id: '/$episodeId',path: '/$episodeId',getParentRoute: () => SlugOfferRoute
          })





const SlugOfferRouteChildren = {
  SlugOfferEpisodeIdRoute: SlugOfferEpisodeIdRoute
}

const SlugOfferRouteWithChildren = SlugOfferRoute._addFileChildren(SlugOfferRouteChildren)



const SlugRouteChildren = {
  SlugEpisodesRoute: SlugEpisodesRoute,SlugOfferRoute: SlugOfferRouteWithChildren,SlugScoreRoute: SlugScoreRoute,SlugIndexRoute: SlugIndexRoute,SlugGameEpisodeIdRoute: SlugGameEpisodeIdRoute
}

const SlugRouteWithChildren = SlugRoute._addFileChildren(SlugRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,SplatRoute: SplatRoute,SlugRoute: SlugRouteWithChildren
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)